<div cdkTrapFocus>
  <mat-progress-spinner mode="indeterminate" [strokeWidth]="7" [diameter]="75"></mat-progress-spinner>
</div>
